export default "__VITE_ASSET__BCgVDYMx__"